import React, { useState } from "react";
import AppContent from "./AppContent";
import Footer from "../Layout/Footer";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { ToastContainer, } from "react-toastify";

function DefaultLayout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <React.Fragment>
      {/* <div className="w-full h-screen flex flex-col">
      
      <Header toggle={toggleSidebar} />

   
      

      
      <div className="flex flex-grow transition-all duration-300 ease-in-out">
        
        <div
          className={`${
            isSidebarOpen ? 'w-1/4' : 'w-0'
          } overflow-hidden bg-gray-200 transition-all duration-300 ease-in-out`}
        >
          <Sidebar />
        </div>

       
        <div
          className={`${
            isSidebarOpen ? 'w-3/4' : 'w-full'
          } flex-grow transition-all duration-300 ease-in-out bg-white`}
        >
          <AppContent isSidebarOpen={isSidebarOpen} />
        </div>
      </div>

      
      <Footer />
    </div> */}
      {/* below code with double code  */}
      {/* <div className="w-full h-screen flex flex-col">
      
      <div className="flex-shrink-0">
        <Header toggle={toggleSidebar} />
      </div>

    
      <div className="flex flex-grow overflow-hidden">
        
        <div
          className={`transition-all duration-300 ease-in-out ${
            isSidebarOpen ? "w-1/4" : "w-0"
          } bg-gray-200 overflow-hidden`}
        >
          <Sidebar />
        </div>

      
        <div className="flex-grow transition-all duration-300 ease-in-out bg-white">
          <div className="h-full overflow-auto">
            <AppContent isSidebarOpen={isSidebarOpen} />
          </div>
        </div>
      </div>

      
      <div className="flex-shrink-0">
        <Footer />
      </div>
    </div> */}
      <div className="w-full h-screen flex flex-col overflow-hidden">
        {/* Fixed Header */}
        <div className="flex-shrink-0">
          <Header toggle={toggleSidebar} />
        </div>

        {/* Middle Content: Sidebar and Main Content */}
        <div className="flex flex-grow overflow-hidden">
          {/* Sidebar */}
          <div
            className={`transition-all duration-300 ease-in-out ${
              isSidebarOpen ? "w-1/4" : "w-0"
            } bg-gray-200 overflow-hidden`}
          >
            <Sidebar />
          </div>

          {/* Main Content with single scrollbar */}
          <div className="flex-grow transition-all duration-300 ease-in-out bg-white ">
            <AppContent isSidebarOpen={isSidebarOpen} toggle={toggleSidebar} />
          </div>
        </div>

        {/* Fixed Footer */}
        <div className="flex-shrink-0 ">
          <Footer />
        </div>
      </div>
    </React.Fragment>
  );
}

export default DefaultLayout;
